<template>
  <div class="card-wrapper">
    <h2 class="section-title" v-if="title">
      {{ title }}
    </h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "card-wrapper",

  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  background: url(../../assets/img/bubbles.svg) no-repeat center / cover,
    linear-gradient(10deg, $info, $primary, $primary2);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 1rem;

  @include until($small-mobile) {
    padding: 5rem 0.3rem;
  }
}
</style>
